import React, { useEffect, useState } from 'react';

import { getTodayDateString } from '@utils/date';
import Script from 'next/script';

import Box from '@ui/Box';

const AdBanner = ({ adId, sx }) => {
    const [activated, setActivated] = useState(false);
    const today = getTodayDateString();

    useEffect(() => {
        handleActivate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleActivate = () => {
        if (!activated && window.activateBanner) {
            window.activateBanner(adId);
            setActivated(true);
        }
    };

    return (
        <Box sx={sx}>
            <div id={adId}></div>
            <Script
                src={`https://cdn.atmedia.hu/atalon.hu.js?v=${today}`}
                strategy="afterInteractive"
                onLoad={handleActivate}
            />
        </Box>
    );
};

export default AdBanner;
